'use client'

import { useEffect } from 'react'
import { captureFirstTouch } from './firstTouch'

/** Records first-touch attribution once, on the first page view of this browser. Renders nothing. */
export function FirstTouchCapture() {
  useEffect(() => {
    captureFirstTouch()
  }, [])

  return null
}
